import { IDateFinderData } from 'redhotpie-shared-lib/interfaces/INewFeed';
import * as utils from '../functions/utils';
import owner from './owner';
import { IContentItem } from 'redhotpie-shared-lib/interfaces/ICommunity';

export default class DateFinder {
  parrentType: string;
  isMemberLike: boolean;
  itemList: IContentItem[];

  constructor() {
    this.parrentType = '';
    this.isMemberLike = false;
    this.itemList = [];
  }

  static mappingItem(_obj: IDateFinderData): any {
    const obj: any = {};
    const { Owner } = _obj;
    obj.id = _obj.ID;
    obj.parentType = _obj.ParentType ? _obj.ParentType : '';
    obj.isMemberLike = _obj.IsMemberLike ? _obj.IsMemberLike : false;
    obj.owner = Owner ? owner.mappingObject(Owner) : {};
    obj.dateFinderItem = _obj.DateFinderItem
      ? {
          city: _obj.DateFinderItem.City ? _obj.DateFinderItem.City : '',
          dateHeld: _obj.DateFinderItem.DateHeld ? _obj.DateFinderItem.DateHeld : '',
          dateID: _obj.DateFinderItem.DateID,
          description: _obj.DateFinderItem.Description ? _obj.DateFinderItem.Description : '',
          isInterestExpressed: _obj.DateFinderItem.IsInterestExpressed,
          state: _obj.DateFinderItem.State ? _obj.DateFinderItem.State : '',
          stateAbbr: _obj.DateFinderItem.StateAbbr ? _obj.DateFinderItem.StateAbbr : '',
        }
      : {};

    return obj;
  }

  static mappingItemList(data: IDateFinderData[]): IContentItem[] {
    return data.map(item => DateFinder.mappingItem(item));
  }

  static mappingObject(_obj: IDateFinderData): IContentItem {
    let obj = Object.assign(new DateFinder(), _obj);
    obj.parrentType = _obj.ParentType ? _obj.ParentType : '';
    obj.isMemberLike = _obj.IsMemberLike ? _obj.IsMemberLike : false;
    obj.itemList = _obj.ItemList ? DateFinder.mappingItemList(_obj.ItemList) : [];

    obj = utils.cleanObjectKeys(Object.keys(new DateFinder()), obj);
    return obj;
  }

  static mappingObjects(_data: IDateFinderData[]): IContentItem[] {
    return _data.map(item => DateFinder.mappingObject(item));
  }
}
